import React from 'react';

const EditExamModal = ({ 
  examForm, 
  handleExamFormChange, 
  handleUpdateExam, 
  loading, 
  onCancel,
  hasExamStarted 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-4 flex items-center justify-between">
          <h4 className="text-xl font-bold text-gray-900">Edit Exam</h4>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <form onSubmit={handleUpdateExam} className="p-8 space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Exam Name *</label>
              <input 
                type="text" 
                name="name" 
                required 
                value={examForm.name} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                placeholder="e.g., Mid-term Mathematics Exam" 
              />
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Start Date *</label>
              <input 
                type="date" 
                name="startDate" 
                required 
                value={examForm.startDate} 
                onChange={handleExamFormChange} 
                disabled={hasExamStarted()} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition disabled:bg-gray-100 disabled:cursor-not-allowed" 
              />
              {hasExamStarted() && <p className="text-xs text-orange-600 mt-1">Cannot modify - exam has already started</p>}
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Start Time *</label>
              <input 
                type="time" 
                name="startTime" 
                required 
                value={examForm.startTime} 
                onChange={handleExamFormChange} 
                disabled={hasExamStarted()} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition disabled:bg-gray-100 disabled:cursor-not-allowed" 
              />
              {hasExamStarted() && <p className="text-xs text-orange-600 mt-1">Cannot modify - exam has already started</p>}
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">End Date *</label>
              <input 
                type="date" 
                name="endDate" 
                required 
                value={examForm.endDate} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
              />
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">End Time *</label>
              <input 
                type="time" 
                name="endTime" 
                required 
                value={examForm.endTime} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
              />
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Total Questions *</label>
              <input 
                type="number" 
                name="totalQuestions" 
                required 
                min="1" 
                value={examForm.totalQuestions} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                placeholder="e.g., 50" 
              />
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Total Marks *</label>
              <input 
                type="number" 
                name="totalMarks" 
                required 
                min="1" 
                value={examForm.totalMarks} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                placeholder="e.g., 100" 
              />
              <p className="text-xs text-gray-500 mt-1">
                {examForm.totalQuestions && examForm.marksPerQuestion 
                  ? `Suggested: ${examForm.totalQuestions} × ${examForm.marksPerQuestion} = ${examForm.totalQuestions * examForm.marksPerQuestion}` 
                  : 'Enter total marks manually'}
              </p>
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Marks Per Question (Optional)</label>
              <input 
                type="number" 
                name="marksPerQuestion" 
                min="0.5" 
                step="0.5" 
                value={examForm.marksPerQuestion} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                placeholder="Leave blank for mixed marks" 
              />
            </div>
            
            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Banner Image URL (Optional)</label>
              <input 
                type="url" 
                name="bannerImage" 
                value={examForm.bannerImage} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                placeholder="https://example.com/banner.jpg" 
              />
            </div>
            
            {/* Exam Duration */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Exam Duration (Minutes) *</label>
              <input 
                type="number" 
                name="duration" 
                required 
                min="1" 
                value={examForm.duration} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                placeholder="e.g., 60 for 1 hour" 
              />
            </div>

            {/* Attempt Limit */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Attempt Limit *</label>
              <select 
                name="attemptLimit" 
                required 
                value={examForm.attemptLimit} 
                onChange={handleExamFormChange} 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
              >
                <option value="once">Only Once</option>
                <option value="2">2 Attempts</option>
                <option value="3">3 Attempts</option>
                <option value="custom">Custom Number</option>
                <option value="unlimited">Unlimited Attempts</option>
              </select>
            </div>

            {/* Custom Attempts */}
            {examForm.attemptLimit === 'custom' && (
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Number of Attempts *</label>
                <input 
                  type="number" 
                  name="customAttempts" 
                  required 
                  min="1" 
                  max="100" 
                  value={examForm.customAttempts} 
                  onChange={handleExamFormChange} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" 
                  placeholder="Enter number of attempts (1-100)" 
                />
              </div>
            )}
            
            <div className="md:col-span-2">
              <label className="flex items-center gap-3 cursor-pointer">
                <input 
                  type="checkbox" 
                  name="showResultImmediately" 
                  checked={examForm.showResultImmediately} 
                  onChange={handleExamFormChange} 
                  className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" 
                />
                <div>
                  <span className="text-sm font-semibold text-gray-700">Show Results Immediately</span>
                  <p className="text-xs text-gray-500">Students will see their results right after completing the exam</p>
                </div>
              </label>
            </div>

            {/* Exam Visibility */}
            <div className="md:col-span-2">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Exam Visibility *
              </label>
              <div className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer p-4 border-2 rounded-lg transition hover:bg-indigo-50 has-[:checked]:border-indigo-500 has-[:checked]:bg-indigo-50">
                  <input
                    type="radio"
                    name="visibility"
                    value="organization"
                    checked={examForm.visibility === 'organization'}
                    onChange={handleExamFormChange}
                    className="mt-1 w-5 h-5 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-gray-700">Organization Only</span>
                      <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded">Private</span>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">Only students from your organization can access this exam</p>
                  </div>
                </label>
                
                <label className="flex items-start gap-3 cursor-pointer p-4 border-2 rounded-lg transition hover:bg-green-50 has-[:checked]:border-green-500 has-[:checked]:bg-green-50">
                  <input
                    type="radio"
                    name="visibility"
                    value="public"
                    checked={examForm.visibility === 'public'}
                    onChange={handleExamFormChange}
                    className="mt-1 w-5 h-5 text-green-600 border-gray-300 focus:ring-green-500"
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-gray-700">Public Exam</span>
                      <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded">Public</span>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">Available to all organizations. Other admins can also see and use this exam</p>
                  </div>
                </label>
              </div>
            </div>
          </div>
          
          <div className="flex gap-4 pt-4 border-t border-gray-200">
            <button 
              type="submit" 
              disabled={loading} 
              className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg transition disabled:opacity-50"
            >
              {loading ? 'Updating...' : 'Update Exam'}
            </button>
            <button 
              type="button" 
              onClick={onCancel} 
              className="bg-gray-200 text-gray-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditExamModal;
